<template>
  <DashboardTableWrapper
    title="Performance des vendeurs"
    :loading="loading"
    :error="error"
    :has-data="!!data && data.length > 0"
    @retry="refresh"
  >
    <table class="w-full text-sm">
      <thead>
        <tr class="bg-gray-50 text-left">
          <th class="px-4 py-3 font-semibold text-gray-600">#</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Vendeur</th>
          <th class="px-4 py-3 font-semibold text-gray-600 cursor-pointer hover:text-primary" @click="sortBy('sales_count')">
            Nb ventes {{ sortIcon('sales_count') }}
          </th>
          <th class="px-4 py-3 font-semibold text-gray-600 cursor-pointer hover:text-primary" @click="sortBy('revenue_ttc')">
            CA TTC {{ sortIcon('revenue_ttc') }}
          </th>
          <th class="px-4 py-3 font-semibold text-gray-600 cursor-pointer hover:text-primary" @click="sortBy('avg_basket')">
            Panier moyen {{ sortIcon('avg_basket') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in sortedData" :key="item.id" class="border-t border-gray-100 hover:bg-gray-50">
          <td class="px-4 py-3 text-gray-400">{{ idx + 1 }}</td>
          <td class="px-4 py-3 font-medium text-gray-800">{{ item.name }}</td>
          <td class="px-4 py-3 font-semibold">{{ item.sales_count }}</td>
          <td class="px-4 py-3 font-semibold text-primary">{{ formatCurrency(item.revenue_ttc) }}</td>
          <td class="px-4 py-3">{{ formatCurrency(item.avg_basket) }}</td>
        </tr>
      </tbody>
    </table>
  </DashboardTableWrapper>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import { formatCurrency } from './helpers'
import DashboardTableWrapper from './DashboardTableWrapper.vue'

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/tables/user-performance', dateParams)

const sortField = ref('revenue_ttc')
const sortDir = ref('desc')

const sortBy = (field) => {
  if (sortField.value === field) {
    sortDir.value = sortDir.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortField.value = field
    sortDir.value = 'desc'
  }
}

const sortIcon = (field) => {
  if (sortField.value !== field) return ''
  return sortDir.value === 'asc' ? '↑' : '↓'
}

const sortedData = computed(() => {
  if (!data.value) return []
  return [...data.value].sort((a, b) => {
    const m = sortDir.value === 'asc' ? 1 : -1
    return (a[sortField.value] - b[sortField.value]) * m
  })
})
</script>
